var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamMembers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444d63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8.836c0-.604-.265-1.179-.738-1.554C7.539 6.708 6.285 6 4.5 6S1.461 6.708.738 7.282C.265 7.657 0 8.232 0 8.836V10h9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.262 7.282C14.539 6.708 13.285 6 11.5 6c-.561 0-1.063.075-1.519.189A3.954 3.954 0 0111 8.836V10h5V8.836c0-.604-.265-1.179-.738-1.554z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembers);
export default __webpack_public_path__ + "static/media/team-members.8e3726ec.svg";
export { ForwardRef as ReactComponent };